import { Zap, Layout, Code2, Rocket, Search, Cloud } from 'lucide-react';

const services = [
  {
    icon: Zap,
    title: 'AI Vibe-Code to Production',
    description:
      'You built it with AI and it works — until it doesn\'t. We audit your codebase, close the security gaps, add proper tests and CI/CD, and get it deployed to production. No full rewrites. Surgical, fast, and lasting.',
  },
  {
    icon: Layout,
    title: 'Technical / Solution Architecture',
    description:
      'Systems that scale without falling apart. We design the architecture upfront — or untangle the one that grew too fast — so you stop paying for tech debt and start shipping features.',
  },
  {
    icon: Code2,
    title: 'App Development',
    description:
      'Full-stack web and mobile, built to last. React, Node.js, .NET, cloud-native on Azure. You get a working product with clean code, real tests, and infrastructure that scales when you do.',
  },
  {
    icon: Rocket,
    title: 'MVP Development',
    description:
      'From idea to shippable product — fast. AI-accelerated build, production-grade foundations from day one. So when investors and users show up, scaling never means starting over.',
  },
  {
    icon: Search,
    title: 'Technical Due Diligence',
    description:
      'Deep-dive code and architecture reviews before a launch, funding round, or acquisition. Security posture, scalability, test coverage, and dependency risk — delivered as a written report.',
  },
  {
    icon: Cloud,
    title: 'Enterprise Integrations',
    description:
      'Getting the systems a business already runs on to talk to each other — CRM, ERP, billing, and third-party APIs. Clean contracts, reliable syncs, no brittle glue code.',
  },
];

export default function Services() {
  return (
    <section id="services" className="services-section">
      <div className="section-inner">
        <h2 className="section-title">Services</h2>
        <p className="section-subtitle">
          Deep problems need deep expertise. Whether you are shipping your first product or
          untangling years of technical debt — we have done it before.
        </p>

        <div className="services-grid">
          {services.map((svc) => {
            const Icon = svc.icon;
            return (
              <div key={svc.title} className="service-card">
                <div className="service-icon-wrap">
                  <Icon size={20} strokeWidth={1.8} />
                </div>
                <h3 className="service-card-title">{svc.title}</h3>
                <p className="service-card-desc">{svc.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
